<template>
<div class="chapter">
<div class="inner_page">
<h1 class="h1fm"><span aria-label="page viii" epub:type="pagebreak" id="page_viii" role="doc-pagebreak"><span aria-label="page ix" epub:type="pagebreak" id="page_ix" role="doc-pagebreak">Author’s Note</span></span></h1>
<p class="noindent">This is a work of satirical fiction.</p>
<p class="indent">Names, characters, places, and events are either the product of the author’s imagination or used in a fictitious manner.</p>
<p class="indent">Any person finding any resemblance between themselves and persons depicted herein should probably be ashamed.</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// authornote.vue?f1197118